import { render, staticRenderFns } from "./ExpirationTimeSelectorPopup.vue?vue&type=template&id=d669545c&"
import script from "./ExpirationTimeSelectorPopup.vue?vue&type=script&lang=ts&"
export * from "./ExpirationTimeSelectorPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports